////////////////////////////////////////////////////////////
//                                                        //
//  Program: VoucherService.js                              //
//  Application: Voucher                                    //
//  Option: Used for voucher validation and usage           //
//  Developer: Ashish Kumar                                 //
//  Date: 2026-03-19                                        //
//                                                        //
////////////////////////////////////////////////////////////

import ApiService from "./ApiService";

class VoucherService {
  getVouchers(queryString) {
    let endPoint = "vouchers" + (queryString ? "?" + queryString : "");
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.getCall(inputData);
    return response;
  }

  getVoucherByCode(voucherCode) {
    let endPoint = "vouchers/" + voucherCode;
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.getCall(inputData);
    return response;
  }

  updateVoucher(voucherCode, data) {
    let endPoint = "vouchers/" + voucherCode;
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.putCall(inputData);
    return response;
  }

  applyVoucher(data) {
    let endPoint = "voucher/apply";
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.postCall(inputData);
    return response;
  }

  markVoucherUsed(data) {
    let endPoint = "voucher/use";
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.postCall(inputData);
    return response;
  }

  sendVoucherEmail(voucherCode, data) {
    let endPoint = "vouchers/" + voucherCode + "/send-email";
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.postCall(inputData);
    return response;
  }

  previewVoucherEmail(voucherCode, data) {
    let endPoint = "vouchers/" + voucherCode + "/preview-email";
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.postCall(inputData);
    return response;
  }

  getEligibleReservationsForVoucher(queryString = "") {
    const endPoint =
      "vouchers/eligible-reservations" + (queryString ? "?" + queryString : "");
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.getCall(inputData);
    return response;
  }

  manualCreateVoucher(data) {
    const endPoint = "vouchers/manual-create";
    let addditionalHeaderData = {};
    let postData = data;

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };
    let response = ApiService.postCall(inputData);
    return response;
  }
}

export default new VoucherService();
